<template>
  <div id="app">
      <VueCookieAcceptDecline
          :id="elementId"
          @elementId="elementId"
          :debug="false"
          :position="'bottom'"
          :transitionName="'slideFromBottom'"
          @getCookieStatus="cookieStatus"
          @clickedAccept="accept"
          
          > 
          <div slot="message">
              <strong>Deze website maakt gebruik van cookies.</strong>
              <p class="cookie_msg">
              We gebruiken cookies voor een optimale website ervaring. Weten wat dit betekent? Lees onze 
              <a href="assets/docs/Privacy_Policy_HorseTraq_v0.1.pdf">Privacy Policy</a>
              voor meer informatie
              </p>
          </div>
          <!-- <div slot="declineContent"> -->
            <!-- Weigeren -->
          <!-- </div> -->

          <!-- Optional -->
          <div slot="acceptContent">
              Sluit deze melding
          </div>
      </VueCookieAcceptDecline>
      <router-view></router-view>

      
  </div>
</template>

<script>
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
export default {
  name: 'app',
  components: {
    VueCookieAcceptDecline
  },
  data() {
      return {
        status: false,
        isOpen: true,
        cookieStatus: null,
        elementId: '',
      }
  },
  mounted () {
    
  },

  methods: {
        setCookieStatus (type) {
          if (type === 'accept') {
              localStorage.setItem(`vue-cookie-accept-decline`, 'accept')
          }
          if (type === 'decline') {
              localStorage.setItem(`vue-cookie-accept-decline`, 'decline')
          }
          if (type === 'postpone') {
              localStorage.setItem(`vue-cookie-accept-decline`, 'postpone')
          }
        },
        getCookieStatus () {
            return localStorage.getItem(`vue-cookie-accept-decline`)
        },
        clickedAccept () {
          this.accept();
        },
        accept () {
            this.status = 'accept'
            this.isOpen = false
            this.$emit('clicked-accept')
        },
        clickedDecline () {
          this.decline();
        },
        decline () {
            this.status = 'decline'
            this.isOpen = false
            this.$emit('clicked-decline')
        },
        postpone () {
            if (!this.debug) {
                this.setCookieStatus('postpone')
            }
            this.status = 'postpone'
            this.isOpen = false
            this.$emit('clicked-postpone')
        },
        removeCookie () {
            localStorage.removeItem('vue-cookie-accept-decline')
            this.status = null
            this.$emit('removed-cookie')
        }
  }
}


</script>

